import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import firebase from 'firebase';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

const FormContainer = styled.div`
font-family: 'Montserrat', sans-serif;
height: 100vh;
padding: 0.8em;
background: #0063c0;
margin: 0 auto;
color: #0063c0;
margin-left: 230px;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
  }
`
const FormBox = styled.div`
position: relative;
margin: 40px auto;
height: 250px; width: 350px;
background: #FFF;
border-radius: 10px;
box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11),
            0 5px 15px 0 rgba(0,0,0,0.08);
text-align: left;
padding: 5px 0;
`
const HeaderSignIn = styled.h5`
font-size: 30px;
`
const SpaceForText = styled.div`
margin: 0 40px;
`

const uiConfig = {
  signInFlow: 'popup',
  signInSuccessUrl: '/create',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID
  ]
};

class SignIn extends Component {
  render() {
    const { auth } = this.props;
    if (auth.uid) return <Redirect to='/' /> 
    return (
      <FormContainer >
        <FormBox>
          <SpaceForText>
              <HeaderSignIn>Sign in with Google to Post</HeaderSignIn>
              <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
          </SpaceForText>
        </FormBox>
      </FormContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return{
    auth: state.firebase.auth
  }
}

export default connect(mapStateToProps)(SignIn)



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js